"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactPlayer = require("react-player");

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _portraitVideoProps = require("./portraitVideoProps");

var _portraitVideoProps2 = _interopRequireDefault(_portraitVideoProps);

var _styled = require("./styled.pVideoCard");

var _addonKnobs = require("@storybook/addon-knobs");

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getVideoIdId = _baseHelper2.default.getVideoIdId,
    getPropValue = _baseHelper2.default.getPropValue;


var PortraitVideo = function PortraitVideo(props) {
  var newProps = _extends({}, _portraitVideoProps2.default.props, props);

  var _useState = (0, _react.useState)("jJJX1Yrp4_Y"),
      _useState2 = _slicedToArray(_useState, 2),
      url = _useState2[0],
      setURL = _useState2[1];

  var media = newProps.media,
      style = newProps.style,
      content = newProps.content,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode,
      links = newProps.links;


  (0, _react.useEffect)(function () {
    var videoId = getVideoIdId(media.videoUrl);
    setURL(videoId);
  }, [props]);

  var linkTitle = getPropValue("text", "link1", links.link, "content");
  var linkUrl = getPropValue("text", "url1", links.url, "content");
  var title = getPropValue("text", "title", content.title, "content");
  var bodyParagraph = getPropValue("text", "paragraph", content.paragraph, "content");

  var titleProps = {
    titleColor: getPropValue("text", "titleColor", style.titleColor, "style"),
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style"),
    bottomSpace: getPropValue("text", "bottomSpace", style.bottomSpace, "style")
  };

  var styledWrapperProps = {
    textFontSize: getPropValue("text", "textFontSize", style.textFontSize, "style"),
    textColor: getPropValue("text", "textColor", style.textColor, "style")
  };

  var iframeProps = {
    iframeHeight: getPropValue("text", "iframeHeight", style.iframeHeight, "style"),
    radius: getPropValue("text", "radius", style.iframeRadius, "style")
  };

  var paragraphStyle = {
    contentSpace: getPropValue("text", "contentSpace", style.contentSpace, "style")
  };

  return _react2.default.createElement(
    _styled.StyledWrapper,
    styledWrapperProps,
    _react2.default.createElement(
      _reactBootstrap.Container,
      { className: "mb-4 VideoCard" },
      _react2.default.createElement(
        _reactBootstrap.Card,
        { className: "w-100" },
        _react2.default.createElement(
          "div",
          { className: "player-wrapper" },
          _react2.default.createElement(_reactPlayer2.default, {
            url: media.videoUrl,
            playing: false,
            controls: true,
            className: "react-player",
            width: "100%",
            height: "100%"
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Card.Body,
          null,
          _react2.default.createElement(
            _styled.Title,
            titleProps,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "title",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: title
            })
          ),
          _react2.default.createElement(
            _styled.Paragraph,
            paragraphStyle,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "paragraph",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: bodyParagraph
            })
          )
        )
      )
    )
  );
};
exports.default = PortraitVideo;